import type { CSSProperties, ReactNode } from "react";

type EyebrowProps = {
  children: ReactNode;
  color?: string;
  style?: CSSProperties;
};

export function Eyebrow({ children, color, style }: EyebrowProps) {
  return (
    <div
      style={{
        fontFamily: "var(--ui)",
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: "0.22em",
        textTransform: "uppercase",
        color: color ?? "var(--text-2)",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
